import { render, staticRenderFns } from "./EditFormString.vue?vue&type=template&id=0fcf50cb"
import script from "./EditFormString.vue?vue&type=script&lang=js"
export * from "./EditFormString.vue?vue&type=script&lang=js"
import style0 from "./EditFormString.vue?vue&type=style&index=0&id=0fcf50cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports